var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImprovePerformance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 67.561 62.097",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15738",
    "data-name": "Group 15738",
    transform: "translate(-1243.75 -4440.702)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28193",
    "data-name": "Path 28193",
    d: "M1313.115,298.934h-65.168a.949.949,0,0,0,0,1.9h65.168a.949.949,0,0,0,0-1.9Z",
    transform: "translate(-3 4201.717)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeLinecap: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28194",
    "data-name": "Path 28194",
    d: "M1312.1,242.12l-4.474-7.594a1.215,1.215,0,0,0-1.5-.425h0l-8.938,3.8a.891.891,0,0,0-.505,1.273,1.214,1.214,0,0,0,1.5.425l6.476-2.748-1.764,4.285c-7.763,18.787-27.771,31.967-51.131,33.686l.193,1.9c24.234-1.783,44.995-15.461,53.051-34.957l1.8-4.377,3.289,5.586a1.215,1.215,0,0,0,1.5.425A.886.886,0,0,0,1312.1,242.12Z",
    transform: "translate(-3.387 4207)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28195",
    "data-name": "Path 28195",
    d: "M1260.808,286.6h-7.827a1.039,1.039,0,0,0-1.112.949v5.7a1.039,1.039,0,0,0,1.112.949h7.827a1.047,1.047,0,0,0,1.121-.949v-5.7A1.047,1.047,0,0,0,1260.808,286.6Zm-1.121,5.7H1254.1v-3.8h5.585Z",
    transform: "translate(-3.396 4202.72)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28196",
    "data-name": "Path 28196",
    d: "M1274.188,283.5h-7.818a1.042,1.042,0,0,0-1.121.949v8.543a1.042,1.042,0,0,0,1.121.95h7.818a1.042,1.042,0,0,0,1.121-.95v-8.543A1.042,1.042,0,0,0,1274.188,283.5Zm-1.112,8.543h-5.594V285.4h5.594Z",
    transform: "translate(-4.485 4202.973)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28197",
    "data-name": "Path 28197",
    d: "M1287.578,278.334h-7.827a1.048,1.048,0,0,0-1.121.949v13.29a1.048,1.048,0,0,0,1.121.949h7.827a1.039,1.039,0,0,0,1.112-.949v-13.29A1.039,1.039,0,0,0,1287.578,278.334Zm-1.121,13.29h-5.585V280.233h5.585Z",
    transform: "translate(-5.573 4203.393)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28198",
    "data-name": "Path 28198",
    d: "M1300.958,271.1h-7.827a1.039,1.039,0,0,0-1.112.949v19.934a1.039,1.039,0,0,0,1.112.949h7.827a1.048,1.048,0,0,0,1.121-.949V272.05A1.047,1.047,0,0,0,1300.958,271.1Zm-1.121,19.934h-5.585V273h5.585Z",
    transform: "translate(-6.663 4203.981)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28199",
    "data-name": "Path 28199",
    d: "M1314.338,256.635h-7.818a1.048,1.048,0,0,0-1.121.949v33.224a1.048,1.048,0,0,0,1.121.95h7.818a1.042,1.042,0,0,0,1.121-.95V257.584A1.042,1.042,0,0,0,1314.338,256.635Zm-1.111,33.224h-5.595V258.533h5.595Z",
    transform: "translate(-7.751 4205.158)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImprovePerformance);
export default __webpack_public_path__ + "static/media/ImprovePerformance.4857d8a0393c0ffec9f3c927ae683ff2.svg";
export { ForwardRef as ReactComponent };